import React from "react";
import {
    Chip,
    Div,
    ModalPage,
    ModalPageHeader,
    ModalRoot,
    Panel,
    PanelHeaderButton,
    SplitCol,
    SplitLayout,
    Title,
    View
} from "@vkontakte/vkui";
import {Icon24Dismiss} from "@vkontakte/icons";
import BaseComponent from "../components/BaseComponent";
import {AdaptivityContext} from "../assets/constants";
import StandCollectionBindingsList from "../references/standcollectionbindings/List";
import CollectionProductCatalog from "../references/standcollections/CollectionProductCatalog";
import StandCollectionQuickForm from "../references/standcollections/StandCollectionQuickForm";

const MODAL_COLLECTION = 'collection_form'

class FragmentStandCollectionBindings extends BaseComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
            selected: null,
            showCatalog: false,
            activeModal: null,
            editing: null,
            existingTitles: [],
            reloadToken: 0,
            countPatch: null,
            boundProducts: [],
            pillTip: null,
        }
    }

    selectCollection = (item) => {
        const same = this.state.selected && Number(this.state.selected.id) === Number(item.id)
        this.setState({
            selected: item,
            showCatalog: true,
            boundProducts: same ? this.state.boundProducts : [],
        })
    }

    closeCatalog = () => {
        this.setState({showCatalog: false})
    }

    openCreate = () => {
        this.setState({activeModal: MODAL_COLLECTION, editing: null})
    }

    openEdit = (item) => {
        this.setState({activeModal: MODAL_COLLECTION, editing: item})
    }

    closeModal = () => {
        this.setState({activeModal: null, editing: null})
    }

    onItems = (items) => {
        this.setState({
            existingTitles: (items || []).map(item => item.title)
        })
    }

    onSaved = (data) => {
        this.setState({
            activeModal: null,
            editing: null,
            selected: data,
            showCatalog: true,
            reloadToken: Date.now(),
        })
    }

    onDeleted = (item) => {
        const selectedGone = this.state.selected && Number(this.state.selected.id) === Number(item.id)
        this.setState({
            selected: selectedGone ? null : this.state.selected,
            showCatalog: selectedGone ? false : this.state.showCatalog,
            boundProducts: selectedGone ? [] : this.state.boundProducts,
            reloadToken: Date.now(),
        })
    }

    onBindingChange = (productsCount) => {
        const selected = this.state.selected
        if (!selected || productsCount == null) {
            return
        }
        const count = Number(productsCount)
        this.setState({
            selected: {...selected, products_count: count},
            countPatch: {id: selected.id, count, token: Date.now()},
        })
    }

    onBoundProducts = (products) => {
        this.setState({boundProducts: products || []})
    }

    removeBoundProduct = (product) => {
        if (this.catalog && this.catalog.removeBound) {
            this.catalog.removeBound(product)
        }
    }

    dedupeBoundProducts = (products) => {
        const groups = new Map()
        ;(products || []).forEach((product) => {
            const key = this.pillIdentity(product)
            const group = groups.get(key) || []
            group.push(product)
            groups.set(key, group)
        })
        const fresh = []
        groups.forEach((group) => {
            const active = group.filter(product => Number(product.marked_deleted) !== 1)
            if (active.length) {
                fresh.push(...active)
                return
            }
            const marked = group.slice().sort((left, right) =>
                (Number(right.unbound_at) || 0) - (Number(left.unbound_at) || 0)
            )
            if (marked.length) {
                fresh.push(marked[0])
            }
        })
        return fresh.sort((left, right) =>
            String(left.title || left.name || '').localeCompare(String(right.title || right.name || ''), 'ru')
        )
    }

    pillIdentity = (product) => {
        const title = String(product.title || product.name || '').trim()
        const code = title.match(/\b(V\d+\s+.+?)\s+(?:BY|RU)\s*$/i)
        if (code) {
            return code[1].replace(/\s+/g, ' ').trim().toLowerCase()
        }
        return 'id:' + Number(product.id)
    }

    boundTip = (product) => {
        const created = Number(
            Number(product.marked_deleted) === 1
                ? (product.unbound_at || 0)
                : (product.created || product.linked_created || 0)
        )
        const login = product.user_login || product.linked_user_login || ''
        const stamp = created
            ? new Date(created * 1000).toLocaleString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            })
            : ''
        if (Number(product.marked_deleted) === 1) {
            const who = product.unbound_user_login || ''
            if (who && stamp) {
                return `Отвязал ${who}, ${stamp}`
            }
            if (who) {
                return `Отвязал ${who}`
            }
            if (stamp) {
                return `Отвязано ${stamp}`
            }
            return 'Помечен на удаление'
        }
        if (login && stamp) {
            return `Привязал ${login}, ${stamp}`
        }
        if (login) {
            return `Привязал ${login}`
        }
        if (stamp) {
            return `Привязано ${stamp}`
        }
        return 'Автор и время не записаны'
    }

    showPillTip = (event, product) => {
        const rect = event.currentTarget.getBoundingClientRect()
        const top = rect.bottom + 8
        this.setState({
            pillTip: {
                text: this.boundTip(product),
                removed: Number(product.marked_deleted) === 1,
                left: Math.max(8, rect.left),
                top: top + 40 > window.innerHeight ? rect.top - 8 : top,
                above: top + 40 > window.innerHeight,
            }
        })
    }

    hidePillTip = () => {
        if (this.state.pillTip) {
            this.setState({pillTip: null})
        }
    }

    renderBoundPills = () => {
        const products = this.dedupeBoundProducts(this.state.boundProducts)
        if (!this.state.selected || !products.length) {
            return null
        }
        const aboveChrome = AdaptivityContext.isMobile ? 0 : 48
        return <div className="collection-bound-pills" style={{
            flex: '0 0 auto',
            marginBottom: aboveChrome,
            background: 'var(--vkui--color_background_content)',
            borderTop: '1px solid var(--vkui--color_separator_primary)',
            maxHeight: 280,
            overflow: 'auto',
        }}>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 6, padding: '8px 12px'}}>
                {products.map((product) => (
                    <span
                        className="collection-bound-pill"
                        key={'bound-' + product.id}
                        onMouseEnter={(event) => this.showPillTip(event, product)}
                        onMouseLeave={this.hidePillTip}
                    >
                        <Chip
                            className={Number(product.marked_deleted) === 1 ? 'collection-bound-pill--removed' : undefined}
                            style={{maxWidth: '100%', minWidth: 0}}
                            removable
                            onRemove={() => this.removeBoundProduct(product)}
                        >
                            {product.title || product.name}
                        </Chip>
                    </span>
                ))}
            </div>
        </div>
    }

    renderCatalog = () => {
        const selected = this.state.selected
        if (!selected) {
            return <Div style={{padding: 24}}>
                <Title level="3" weight="2">Выберите коллекцию</Title>
            </Div>
        }
        return <CollectionProductCatalog
            ref={(node) => {
                this.catalog = node
            }}
            key={selected.id}
            liveBinding
            collectionId={selected.id}
            collectionTitle={selected.title}
            current_group_id=""
            onBindingChange={this.onBindingChange}
            onBoundProducts={this.onBoundProducts}
            onClose={AdaptivityContext.isMobile ? this.closeCatalog : undefined}
        />
    }

    renderCollectionModal = (mobile) => {
        const modal = <ModalRoot activeModal={this.state.activeModal} onClose={this.closeModal}>
            <ModalPage
                id={MODAL_COLLECTION}
                {...(mobile ? {settlingHeight: 100} : {})}
                header={<ModalPageHeader after={
                    <PanelHeaderButton onClick={this.closeModal}><Icon24Dismiss/></PanelHeaderButton>
                }>
                    {this.state.editing ? 'Коллекция' : 'Новая коллекция'}
                </ModalPageHeader>}
                onClose={this.closeModal}
            >
                <StandCollectionQuickForm
                    key={this.state.editing ? this.state.editing.id : 'new'}
                    collection={this.state.editing}
                    existingTitles={this.state.existingTitles}
                    onSaved={this.onSaved}
                    onCancel={this.closeModal}
                />
            </ModalPage>
        </ModalRoot>
        if (mobile && this.state.activeModal) {
            return <div className="stand-kit-modal-host">{modal}</div>
        }
        return modal
    }

    render() {
        const mobile = AdaptivityContext.isMobile
        const showCollections = !mobile || !this.state.showCatalog
        const showProducts = !mobile || this.state.showCatalog
        return <View activePanel="panel_stand_collection_bindings">
            <Panel id="panel_stand_collection_bindings">
                <SplitLayout>
                    {mobile ? '' : this.MainMenu()}
                    {showCollections && <SplitCol width={mobile ? '100%' : 0} minWidth={0} style={mobile ? undefined : {flex: '1 1 0'}}>
                        <div style={{display: 'flex', flexDirection: 'column', height: mobile ? 'auto' : 'calc(100vh - 52px)'}}>
                            <div style={{flex: '1 1 auto', minHeight: 0, overflowY: mobile ? 'visible' : 'auto'}}>
                                <StandCollectionBindingsList
                                    current_user={this.props.current_user}
                                    selectedId={this.state.selected && this.state.selected.id}
                                    reloadToken={this.state.reloadToken}
                                    countPatch={this.state.countPatch}
                                    onSelect={this.selectCollection}
                                    onCreate={this.openCreate}
                                    onEdit={this.openEdit}
                                    onDeleted={this.onDeleted}
                                    onItems={this.onItems}
                                />
                            </div>
                            {this.renderBoundPills()}
                        </div>
                    </SplitCol>}
                    {showProducts && <SplitCol width={mobile ? '100%' : 0} minWidth={0} style={mobile ? undefined : {flex: '1 1 0'}}>
                        {this.renderCatalog()}
                    </SplitCol>}
                </SplitLayout>
                {this.renderCollectionModal(mobile)}
                {this.state.pillTip && <div
                    className={'collection-bound-pill-tip' + (this.state.pillTip.above ? ' collection-bound-pill-tip--above' : '') + (this.state.pillTip.removed ? ' collection-bound-pill-tip--removed' : '')}
                    style={{left: this.state.pillTip.left, top: this.state.pillTip.above ? undefined : this.state.pillTip.top, bottom: this.state.pillTip.above ? (window.innerHeight - this.state.pillTip.top) : undefined}}
                >
                    {this.state.pillTip.text}
                </div>}
            </Panel>
        </View>
    }
}

export default FragmentStandCollectionBindings
